var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"dot-spinner"},_vm._l((12),function(index){return _c('div',{key:index,class:'dot dot-' + index,style:({ backgroundColor: _vm.currentColor })})}),0),_c('span',{staticClass:"loader-text ml-4"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }